import { useEffect, useState } from 'react'
import { Box, CircularProgress } from "@material-ui/core";

import { MapContainer, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import { openStreetMap } from '../../../constants/index'
import { useDispatch, useSelector } from "react-redux";

const CourseMap = () => {
    const { course } = useSelector((state) => state.courses);
    const [hasCoordinates, setHasCoordinates] = useState(false);
    const [coordinates, setCoordinates] = useState();
    const [coordinatesNotFound, setCoordinatesNotFound] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        let ignore = false;

        // Fetch course by address if coordinates are not available in db
        if (course.name && (course.coordinates === undefined || course.coordinates === '')) {
            startFetching();
        }

        // Set coordinates if coordinates are available in db
        if (course.name && course.coordinates !== undefined && course.coordinates !== '') {
            let coordinates = course?.coordinates?.replace(/[()]/g, '').split(',')
            let latAndLong = course.coordinates && { lat: parseFloat(coordinates[0]), lng: parseFloat(coordinates[1]) }

            setCoordinates({ lat: latAndLong.lat, lng: latAndLong.lng })
            setHasCoordinates(true)
        }

        async function startFetching() {
            try {
                const result = await fetch(`https://nominatim.openstreetmap.org/search?street=${course.address || course.name}&city=${course.city}&state=${course.state}&format=json&limit=1`)
                    .then(response => response.json());
                if (!ignore) {
                    if (result && result.length > 0) {
                        setCoordinates({ lat: result[0].lat, lng: result[0].lon })
                        setHasCoordinates(true)
                    } else {
                        setCoordinatesNotFound(true)
                    }
                }
            } catch (error) {
                console.error('Failed to fetch coordinates:', error);
                setCoordinatesNotFound(true)
            }
            return () => {
                ignore = true;
            }
        }

    }, [dispatch, course.name]);

    return (
        <Box style={{ height: '500px', width: '100%', maxWidth: '550px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {hasCoordinates ? (
                <MapContainer
                    center={[coordinates.lat, coordinates.lng]}
                    zoom={15}
                    scrollWheelZoom={true}
                    style={{ height: '500px', width: '100%' }}>
                    <TileLayer
                        attribution={openStreetMap.ATTRIBUTION}
                        url={openStreetMap.URL}
                    />
                </MapContainer>
            ) : coordinatesNotFound ? (
                <Box style={{ textAlign: 'center', color: '#888' }}>Map unavailable for this course</Box>
            ) : (
                <CircularProgress />
            )}
        </Box>
    )
}

export default CourseMap